import { Box, Icon, Link, Typography } from "@mui/material";
import { DropdownModel } from "../../../data/interfaces/sharedmodels";

export default function Support({systemInfo}:{systemInfo:DropdownModel[]}){
    return(
        <Box>
            <Typography variant="h5">Contact Us</Typography>
            <Box sx={{display:'flex',justifyContent:'center'}}>
                <Icon>mail</Icon>
                <Link href={'mailto:'+ (systemInfo.findIndex(a=>a.Id=="SupportMail")>-1?systemInfo.filter(a=>a.Id=="SupportMail")[0].Description :'2.0.0')} target='_blank' rel="noopener noreferrer">
                Mail Us
                </Link>
            </Box>
            
        </Box>
    )
}